import { useEffect, useRef, useState } from "react";
import { MenuItemAction } from "../../Menu/MenuItem.Dto";
import { useNavigate } from "react-router-dom";
import { NFeDto } from "./NFe.Dto";
import { showToast } from "src/componentes";
import { NFeBuscarXML } from "src/services/Fiscal.Service";

type NFeMenuCodeProps = {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  data: NFeDto[];
};

const NFeMenuCode = (props: NFeMenuCodeProps) => {
  const navigate = useNavigate();
  const dataRef = useRef<NFeDto[]>([]);

  useEffect(() => {
    dataRef.current = props.data;
  }, [props.data]);

  const onDownloadXml = async () => {
    props.setLoading(true);
    const dataAtual = dataRef.current;
    if (dataAtual.length === 0) {
      showToast({
        message: "Nenhuma NFe selecionado",
        title: "Atenção",
        variant: "Warning",
      });
      props.setLoading(false);
      return;
    }
    try {
      const primeiro = dataAtual[0];
      const ultimo = dataAtual[dataAtual.length - 1];
      const ids = dataAtual.map((item) => item.id);
      const nomeArquivo = `NFe_${primeiro?.numeroNF}_${ultimo?.numeroNF}`;
      const response = await NFeBuscarXML(ids, nomeArquivo);
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${nomeArquivo}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      showToast({
        message: "Ocorreu erro ao baixar XML",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      props.setLoading(false);
    }
  };

  const menuPrincipal: MenuItemAction[] = [
    {
      id: 1,
      nome: "Nova NFe...",
      rota: "/fiscal/nfe/cadastro",
      sequencia: 1,
      nivel: 1,
      idNivelAnterior: 0,
    },
    {
      id: 2,
      nome: "Baixar XML",
      rota: "",
      sequencia: 2,
      nivel: 1,
      idNivelAnterior: 0,
      action: onDownloadXml,
    },
  ];

  const [menuItens, setMenuItens] = useState<MenuItemAction[]>(menuPrincipal);

  const handleMenuClick = (item: MenuItemAction) => (e: React.MouseEvent) => {
    if (item.children && item.children.length > 0) {
      e.stopPropagation();
      setMenuItens(item.children);
    } else if (item.action) {
      item.action();
    } else if (item.rota) {
      navigate(item.rota);
    }
  };

  const handleMenuToggleClick = (isOpen: boolean) => {
    if (!isOpen) {
      setMenuItens(menuPrincipal);
    }
  };

  return {
    handleMenuClick,
    handleMenuToggleClick,
    menuItens,
  };
};

export default NFeMenuCode;
